import { io } from 'socket.io-client';
import config from './utils/config';

const socket = io(config.host_ws, {
    path: '/ws',
    transports: ['websocket']
  }); 

export default socket;